import Form from 'antd/lib/form';
import Modal from 'antd/lib/modal';
import * as React from 'react';
import { AppComponentProps } from '../../typescriptHelpers';
import { useDispatch } from 'react-redux';
import { FixRequest } from '../../types';
import { globalMessage } from '../../utils/globalMessage';
import Input from 'antd/lib/input';
import { ReleaseStepUpdatable } from '@/actions/updatable';
import { tryUpdateReleaseStep } from '@/actions/releaseStep';
import { useError, useIsLoading, useUpdated } from '@/utils/hooks/helpers';

interface UpdateFixDetailsModalProps extends AppComponentProps {
    releaseId: string;
    onCancel: () => void;
    fixRequest: FixRequest;
    featureItemId: string;
    stepRunId: string;
}

const UpdateFixDetailsModal: React.FC<UpdateFixDetailsModalProps> = (props: UpdateFixDetailsModalProps) => {
    const dispatch = useDispatch();

    const [isModalOpen, setIsModalOpen] = React.useState(true);

    const [form] = Form.useForm();

    const updateFixRequestDetailsLoading = useIsLoading(ReleaseStepUpdatable.UpdateFixRequest, props.fixRequest.id);
    const updateFixRequestDetailsSuccess = useUpdated(ReleaseStepUpdatable.UpdateFixRequest, props.fixRequest.id);
    const updateFixRequestDetailsError = useError(ReleaseStepUpdatable.UpdateFixRequest, props.fixRequest.id);

    React.useEffect(() => {
        if (updateFixRequestDetailsSuccess) {
            globalMessage.success('Fix Request details updated successfully!');
            setIsModalOpen(false);
            props.onCancel();
        }
    }, [updateFixRequestDetailsSuccess]);

    React.useEffect(() => {
        if (updateFixRequestDetailsError) {
            globalMessage.error(updateFixRequestDetailsError);
        }
    }, [updateFixRequestDetailsError]);

    const handleOnSubmit = (values) => {
        const fixDetails = values.fixDetails;

        dispatch(
            tryUpdateReleaseStep(
                ReleaseStepUpdatable.UpdateFixRequest,
                {
                    appId: props.appId,
                    orgId: props.orgId,
                    releaseId: props.releaseId,
                    frItemId: props.featureItemId,
                    stepRunId: props.stepRunId,
                },
                {
                    fixId: props.fixRequest.id,
                    details: fixDetails,
                },
                props.fixRequest.id,
            ),
        );
    };

    return (
        <Modal
            title={'Edit fix details'}
            okText={'Update fix details'}
            open={isModalOpen}
            onCancel={() => {
                setIsModalOpen(false);
                props.onCancel();
            }}
            destroyOnClose={true}
            onOk={() => {
                form.submit();
            }}
            okButtonProps={{ loading: updateFixRequestDetailsLoading }}
        >
            <Form form={form} onFinish={handleOnSubmit}>
                <Form.Item noStyle name="fixDetails">
                    <Input.TextArea rows={5} defaultValue={props.fixRequest?.details} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default UpdateFixDetailsModal;
